import { useMemo, useSyncExternalStore } from 'react'
import {
  formatAccountCurrency,
  formatAccountCurrencyCompact,
  getCurrencyDisplay,
  getCurrencySymbol,
  subscribeCurrencyDisplay,
  type CurrencyDisplay,
} from '@/lib/currency'

export interface UseCurrencyReturn {
  currencyDisplay: CurrencyDisplay
  symbol: string
  formatCurrency: (value: number) => string
  formatCurrencyCompact: (value: number) => string
}

/** Reactive currency helpers bound to the account preference. */
export function useCurrency(): UseCurrencyReturn {
  const currencyDisplay = useSyncExternalStore(
    subscribeCurrencyDisplay,
    getCurrencyDisplay,
    getCurrencyDisplay
  )

  return useMemo(
    () => ({
      currencyDisplay,
      symbol: getCurrencySymbol(currencyDisplay),
      formatCurrency: (value: number) => formatAccountCurrency(value, currencyDisplay),
      formatCurrencyCompact: (value: number) =>
        formatAccountCurrencyCompact(value, currencyDisplay),
    }),
    [currencyDisplay]
  )
}
